/*
 * SPDX-FileCopyrightText: 2022 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
import { MediaFormatSize, ImageLoadingStrategy } from '@boels/models';

/**
 * Provides configuration specific to Media, such as images. This is used to optimize
 * rendering of the media, SEO and performance.
 */

export abstract class MediaConfig {
  /**
   * Media _format_ configuration holds the size of the media's assigned to
   * a format.
   */
  mediaFormats?: {
    /**
     * Represents the media format code, that is the key to distinguish different
     * media in a container.
     */
    [format: string]: MediaFormatSize;
  };

  /**
   * Indicates how the browser should load the image. There's only one
   * global strategy for all media cross media in Spartacus.
   *
   * See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img for more
   * information.
   *
   * If the `lazy` strategy is in place, the `loading="lazy"` attribute is added to the
   * img element.
   */
  imageLoadingStrategy?: ImageLoadingStrategy;
}
export const mediaConfig: MediaConfig = {
  mediaFormats: {
    // banner formats
    mobile: { width: 400 },
    tablet: { width: 770 },
    desktop: { width: 1140 },
    widescreen: { width: 1400 },
    // product formats
    thumbnail: { width: 160 }, // thumbnail
    cartIcon: { width: 320 }, // small
    product: { width: 320 },
    store: { width: 480 }, // medium
    zoom: { width: 1600 }, // large
  },
  /* TODO: PH values for the images we receive at this point
actual expected values:
  thumbnail: { width: 160 }, // thumbnail
  cartIcon: { width: 320 }, // small
  product: { width: 320 },
  store: { width: 480 }, // medium
  zoom: { width: 1600 }, // large
 */
  imageLoadingStrategy: ImageLoadingStrategy.LAZY,
};
